/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {BrowserRouter as Router, Route, Routes} from 'react-router';
import {useCarritoFlotante} from "../Modulo_Carrito_Flotante/Hooks/useCarritoFlotante";
import Seccion_Home from "./Secciones/Seccion_Home";
import Barra from "./Barra/Barra";
import Footer from "./Footer";
import Seccion_Detalles from "./Secciones/Seccion_Detalles";
import Seccione_Catalogo from "./Secciones/Seccione_Catalogo";
import Seccione_Nosotros from "./Secciones/Seccione_Nosotros";
import Seccione_Recibo from "./Secciones/Seccione_Recibo";

const Pagina = () => {
    const {CarritoFlotante} = useCarritoFlotante();

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Router>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 2}}>
                    <Barra/>
                </Grid>


                <Routes>
                    <Route path={"*"} element={<Seccion_Home/>}/>
                    <Route path={"/"} element={<Seccion_Home/>}/>
                    <Route path={"/Home"} element={<Seccion_Home/>}/>
                    <Route path={"/Catalogo"} element={<Seccione_Catalogo/>}/>
                    <Route path={"/Catalogo/:tipo/:id"} element={<Seccione_Catalogo/>}/>
                    <Route path={"/Detalle/:id"} element={<Seccion_Detalles/>}/>
                    <Route path={"/Recibo"} element={<Seccione_Recibo/>}/>
                    <Route path={"/Nosotros"} element={<Seccione_Nosotros/>}/>

                </Routes>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                    <Footer/>
                </Grid>

                <CarritoFlotante/>


            </Router>

        </Grid>
    )

}
export default Pagina    